<div class="title_div">
  <div class="w-100 d-flex justify-content-between align-items-center">

    <div class="proj_id d-flex">
      <div class="title_sub_div_1 mt-1">Part Information :{{projectName}} - Version : {{ version_id }}</div>
    </div>

    <div class="header-actions">
      <button class="icon-btn export-btn" title="Export as Excel" (click)="exportData()">
        <i class="fas fa-file-export"></i> Export
      </button>
      <button class="icon-btn" title="Refresh Part Information data" (click)="refreshPage()">
        <i class="fa fa-refresh"></i>
      </button>
      <button class="icon-btn" title="Dashboard" (click)="home()">
        <i class="fa fa-home"></i>
      </button>
      <button class="icon-btn" title="Go on part view page" (click)="back()">
        <i class="fa fa-arrow-left"></i>
      </button>
    </div>
  </div>
</div>

<div class="cards-section">
  <div class="cards-grid">
    <!-- Card for Internal Part No -->
    <div class="card-wrapper card-ipn-wrapper" title="{{internalPartNo}}">
      <div class="card-item card-primary">
        <div class="card-icon">
          <i class="fas fa-microchip"></i>
        </div>
        <div class="card-content">
          <div class="card-value">{{internalPartNo}}</div>
          <div class="card-label">Internal Part No.</div>
        </div>
      </div>
    </div>

    <!-- Card for Quantity -->
    <div class="card-wrapper card-qty-wrapper" title="{{projectQty | number:'1.2-2'}}">
      <div class="card-item card-secondary">
        <div class="card-icon">
          <i class="fas fa-boxes"></i>
        </div>
        <div class="card-content">
          <div class="card-value">{{projectQty | number:'1.2-2'}}</div>
          <div class="card-label">Quantity</div>
        </div>
      </div>
    </div>

    <!-- Card for Description -->
    <div class="card-wrapper card-description-wrapper" title="{{description}}">
      <div class="card-item card-warning">
        <div class="card-icon">
          <i class="fas fa-file-alt"></i>
        </div>
        <div class="card-content">
          <div class="card-value">{{description}}</div>
          <div class="card-label">Description</div>
        </div>
      </div>
    </div>

    <!-- Card for Criteria -->
    <div class="card-wrapper card-criteria-wrapper" (click)="selectCriteria(criteriaModal)">
      <div class="card-item card-accent">
        <div class="card-icon">
          <i class="fas fa-sliders-h"></i>
        </div>
        <div class="card-content">
          <div class="card-label">Criteria</div>
        </div>
      </div>
    </div>
    <ng-template #criteriaModal let-modal>
      <div class="modal-header">
        <h6 class="modal-title">Criteria</h6>
        <div type="button" title="Close" (click)="closeModal()" style="font-size: 32px; cursor: pointer;">&times;</div>
      </div>
      <div class="modal-body">
        <div class="main-div flex-wrap">
          <div class="form-group modalformGroup">
            <label>
              <input type="checkbox" [(ngModel)]="criteria.stockAvailability" disabled />
              Stock Availability
            </label>
          </div>

          <div class="form-group modalformGroup">
            <label>
              <input type="checkbox" [(ngModel)]="criteria.leadTime" disabled />
              Lead Time
            </label>
          </div>

          <div class="form-group modalformGroup">
            <label>
              <input type="checkbox" [(ngModel)]="criteria.minimumPrice" disabled />
              Minimum Price
            </label>
          </div>
          <div class="form-group modalformGroup">
            <label>
              <input type="checkbox" [(ngModel)]="criteria.authorisedSuppliers" disabled />
              Authorised suppliers
            </label>
          </div>

          <div class="custom-supplier-container">
            <label for="supplierSelection" class="custom-supplier-label">Supplier Selection:</label>
            <ng-select [items]="supplierOptions" [(ngModel)]="criteria.selectedSuppliers" [multiple]="true"
              bindLabel="name" bindValue="name" class="custom-supplier-ng-select" [readonly]="true">
              <ng-template ng-label-tmp let-item="item" let-clear="clear">
                <span class="custom-supplier-selected">{{ item.name }}</span>
              </ng-template>
            </ng-select>
          </div>


        </div>
      </div>
    </ng-template>

    <!-- Card for Sourcing / Parts -->
    <div class="card-wrapper card-sourcing-wrapper" (click)="openSourcingModal(sourcingModal)">
      <div class="card-item card-teal">
        <div class="card-icon">
          <i class="fas fa-cubes"></i>
        </div>
        <div class="card-content">
          <div class="card-label">Parts</div>
        </div>
      </div>
    </div>

    <ng-template #sourcingModal let-modal>
      <div class="submit-modal-wrapper" cdkDrag cdkDragRootElement=".modal-content">
        <div class="submit-modal-header" cdkDragHandle
          style="background: linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%); border-bottom: 1px solid #7dd3fc; cursor: grab; user-select: none;">
          <div class="submit-modal-icon-wrap" style="background: rgba(2, 132, 199, 0.15); color: #0284c7;">
            <i class="fa fa-info-circle"></i>
          </div>
          <div>
            <h5 class="submit-modal-title" style="color: #0369a1; margin: 0; font-weight: 700; display: flex; align-items: center; gap: 8px;">
              Sourcing Relationships
              <i class="fa fa-arrows-alt" style="font-size: 11px; opacity: 0.5;" title="Drag to move"></i>
            </h5>
            <p class="submit-modal-subtitle" style="color: #0c4a6e; margin: 2px 0 0 0;">Internal Part Number: <strong>{{
                internalPartNo }}</strong></p>
          </div>
          <button class="submit-modal-close-btn" (click)="modal.dismiss()" title="Close">
            <i class="fa fa-times"></i>
          </button>
        </div>

        <div class="submit-modal-body" style="padding: 20px;">
          <!-- Loading Spinner -->
          <div *ngIf="isLoadingIpnInfo" class="d-flex flex-column align-items-center justify-content-center"
            style="min-height: 150px;">
            <div class="spinner-border text-primary mb-2" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <div class="text-muted fw-semibold">Fetching relationship details...</div>
          </div>

          <!-- Content -->
          <div *ngIf="!isLoadingIpnInfo">
            <!-- Counts Summary Row -->
            <div style="display: flex; gap: 15px; margin-bottom: 20px; justify-content: space-between;">
              <div class="sourcing-stats-card sourcing-stats-card--mpn">
                <h4 class="stat-val">{{ ipnInfoMpnCount }}</h4>
                <span class="stat-lbl">Matching MPNs</span>
              </div>
              <div class="sourcing-stats-card sourcing-stats-card--mfg">
                <h4 class="stat-val">{{ ipnInfoMfgCount }}</h4>
                <span class="stat-lbl">Manufacturers</span>
              </div>
            </div>

            <!-- Relationships Table -->
            <div *ngIf="ipnInfoRelationships.length > 0" class="table-responsive"
              style="max-height: 250px; overflow-y: auto; border: 1px solid #e2e8f0; border-radius: 8px;">
              <table class="sourcing-rel-table">
                <thead>
                  <tr>
                    <th>MPN (Specification)</th>
                    <th>Manufacturer</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let rel of ipnInfoRelationships">
                    <td style="word-break: break-all;">
                      {{ rel.specification }}
                    </td>
                    <td style="word-break: break-all;">
                      {{ rel.manufacturer }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- No Relationships Found Alert -->
            <div *ngIf="ipnInfoRelationships.length === 0" class="submit-modal-alert" style="margin-bottom: 0;">
              <i class="fa fa-exclamation-triangle submit-modal-alert-icon"></i>
              <div>
                <p class="submit-modal-alert-title">No Relationships Found</p>
                <p class="submit-modal-alert-desc">No active sourcing relationships are defined for this internal part
                  number.</p>
              </div>
            </div>
          </div>
        </div>

        <div class="submit-modal-footer">
          <button type="button" class="submit-modal-btn submit-modal-btn--cancel" (click)="modal.close()">
            Close
          </button>
        </div>
      </div>
    </ng-template>
  </div>
</div>

<div class="specs-modal-backdrop" *ngIf="showSpecsDetails">
  <div class="specs-modal-content">

    <!-- Header Section -->
    <div class="specs-header">
      <div class="specs-header-left">
        <div class="specs-header-icon">
          <i class="fas fa-list-check"></i>
        </div>
        <h5 class="specs-title-text">Part Specifications</h5>
      </div>
      <button type="button" class="specs-close-btn" (click)="closeSpecificationDetails()" title="Close">
        &times;
      </button>
    </div>

    <!-- Quick Info Cards -->
    <div class="specs-cards-section">
      <div class="specs-cards-grid">
        <div class="specs-card specs-card--part" title="{{ selectedPart?.MPN }}">
          <div class="specs-card-icon">
            <i class="fas fa-hashtag"></i>
          </div>
          <div class="specs-card-body">
            <span class="specs-card-label">Part Number</span>
            <span class="specs-card-val">{{ selectedPart?.MPN || 'N/A' }}</span>
          </div>
        </div>

        <div class="specs-card specs-card--mfg" title="{{ selectedPart?.manufacturer }}">
          <div class="specs-card-icon">
            <i class="fas fa-industry"></i>
          </div>
          <div class="specs-card-body">
            <span class="specs-card-label">Manufacturer</span>
            <span class="specs-card-val">{{ selectedPart?.manufacturer || 'N/A' }}</span>
          </div>
        </div>

        <div class="specs-card specs-card--count">
          <div class="specs-card-icon">
            <i class="fas fa-clipboard-list"></i>
          </div>
          <div class="specs-card-body">
            <span class="specs-card-label">Total Specs</span>
            <span class="specs-card-val">{{ selectedSpecs?.length || 0 }} Attribute(s)</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Table Section -->
    <div class="specs-body">
      <!-- Empty State -->
      <div *ngIf="selectedSpecs?.length === 0" class="specs-empty-state">
        <i class="fas fa-inbox"></i>
        <p class="empty-title">No specifications found</p>
        <p class="empty-subtitle">Specifications will appear here</p>
      </div>

      <!-- Specifications Table -->
      <table *ngIf="selectedSpecs?.length > 0" class="specs-rel-table">
        <thead>
          <tr>
            <th style="width: 35%;">
              <i class="fas fa-tag" style="margin-right: 6px; color: #0284c7;"></i>Attribute
            </th>
            <th style="width: 35%;">
              <i class="fas fa-equals" style="margin-right: 6px; color: #0284c7;"></i>Value
            </th>
            <th style="width: 15%;">
              <i class="fas fa-ruler" style="margin-right: 6px; color: #0284c7;"></i>Unit
            </th>
            <th style="width: 15%;">
              <i class="fas fa-folder" style="margin-right: 6px; color: #0284c7;"></i>Group
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let spec of selectedSpecs; let i = index">
            <td style="word-break: break-word; font-weight: 600;">
              <span class="attr-bullet"></span>{{ spec.name }}
            </td>
            <td style="word-break: break-word;">
              <span class="badge-val">{{ spec.value }}</span>
            </td>
            <td style="word-break: break-word;">
              <span class="badge-unit" *ngIf="spec.unitsSymbol">{{ spec.unitsSymbol }}</span>
              <span *ngIf="!spec.unitsSymbol">—</span>
            </td>
            <td style="word-break: break-word;">
              <span class="badge-group">
                <i class="fas fa-folder"></i>{{ spec.group || 'General' }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Footer Section -->
    <div class="specs-footer">
      <span class="specs-footer-info">
        <i class="fas fa-info-circle"></i>
        <span>Showing <strong>{{ selectedSpecs?.length || 0 }}</strong> specification(s)</span>
      </span>
      <button type="button" class="specs-footer-btn" (click)="closeSpecificationDetails()">
        <i class="fas fa-times"></i>Close
      </button>
    </div>

  </div>
</div>

<!-- Alternatives Popup - Enhanced UI -->
<div class="popup-backdrop" *ngIf="showAlternativesPopup">
  <div class="alternatives-modal-content">
    <!-- Header Section -->
    <div class="alternatives-header">
      <div class="alternatives-header-overlay"></div>
      <div class="alternatives-header-content">
        <div class="alternatives-header-left">
          <div class="alternatives-icon-wrap">
            <i class="fas fa-code-branch"></i>
          </div>
          <div>
            <h2 class="alternatives-title">Alternative Parts</h2>
            <p class="alternatives-subtitle">Find compatible alternatives and compatibility details</p>
          </div>
        </div>
        <button type="button" (click)="closeAlternativesPopup()" class="alternatives-close">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>

    <!-- Summary Cards Section -->
    <div class="alternatives-summary-section">
      <div class="alternatives-summary-cards">
        <div class="alternatives-card-summary">
          <div class="alternatives-card-label">Original MPN</div>
          <div class="alternatives-card-value">{{ alternativesData?.mpn || 'N/A' }}</div>
        </div>
        <div class="alternatives-card-summary">
          <div class="alternatives-card-label">Manufacturer</div>
          <div class="alternatives-card-value">{{ alternativesData?.manufacturer || 'N/A' }}</div>
        </div>
        <div class="alternatives-card-summary">
          <div class="alternatives-card-label">Total Alternatives</div>
          <div class="alternatives-card-value">{{ alternativesData?.alternatives?.length || 0 }}</div>
        </div>
      </div>
    </div>

    <!-- Table Section -->
    <div class="alternatives-table-section">
      <!-- Empty State -->
      <div *ngIf="!alternativesData?.alternatives || alternativesData?.alternatives?.length === 0"
        class="alternatives-empty-state">
        <div class="alternatives-empty-icon">
          <i class="fas fa-search"></i>
        </div>
        <p class="alternatives-empty-title">No alternatives found</p>
        <p class="alternatives-empty-text">No compatible alternatives available for this part</p>
      </div>

      <!-- Alternatives Table -->
      <div *ngIf="alternativesData?.alternatives && alternativesData?.alternatives?.length > 0"
        class="alternatives-table-scroll">
        <table class="alternatives-table">
          <thead>
            <tr class="alternatives-table-header">
              <th class="alternatives-table-th">
                <i class="fas fa-barcode"></i>MPN
              </th>
              <th class="alternatives-table-th">
                <i class="fas fa-industry"></i>Manufacturer
              </th>
              <th class="alternatives-table-th">
                <i class="fas fa-circle-check"></i>Status
              </th>
              <th class="alternatives-table-th">
                <i class="fas fa-calendar-alt"></i>EOL Date
              </th>
              <th class="alternatives-table-th">
                <i class="fas fa-lightbulb"></i>Compatibility Note
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let alt of alternativesData?.alternatives; let i = index" class="alternatives-table-row">
              <td class="alternatives-table-td">
                <span class="alternatives-mpn-badge">{{ alt.mpn }}</span>
              </td>
              <td class="alternatives-table-td">
                <span class="alternatives-mfg-badge">{{ alt.manufacturer }}</span>
              </td>
              <td class="alternatives-table-td">
                <span [ngClass]="'alternatives-status-' + (alt.eol_status | lowercase)"
                  class="alternatives-status-badge">
                  <i
                    [ngClass]="alt.eol_status === 'Active' ? 'fas fa-check-circle' : (alt.eol_status === 'NRND' ? 'fas fa-exclamation-circle' : 'fas fa-times-circle')"></i>
                  {{ alt.eol_status }}
                </span>
              </td>
              <td class="alternatives-table-td">
                <span *ngIf="alt.eol_date; else noeoldate" class="alternatives-date-badge">{{ alt.eol_date }}</span>
                <ng-template #noeoldate>
                  <span class="alternatives-no-data">No date</span>
                </ng-template>
              </td>
              <td class="alternatives-table-td alternatives-reason-col">
                {{ alt.reason }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Footer Section -->
    <div class="alternatives-footer">
      <span class="alternatives-footer-info">
        <i class="fas fa-info-circle"></i>
        Total: <strong>{{ alternativesData?.alternatives?.length || 0 }}</strong> alternative(s) found
      </span>
      <button type="button" (click)="closeAlternativesPopup()" class="alternatives-btn-close">
        <i class="fas fa-check"></i>Got it
      </button>
    </div>
  </div>
</div>

<div *ngIf="infoMessage" class="alert alert-info">
  {{ infoMessage }}
</div>

<div class="row row_mar mt-1">
  <div class="col-12 grid-margin stretch-card col_pad">
    <div class="card">
      <div class="card-body">
        <div class="table-responsive gd_main_div_mobile">
          <table class="table table-striped custom-hover">
            <thead>
              <tr>
                <th></th>
                <th (click)="sortData('supplier')">
                  Supplier
                  <i [ngClass]="getSortIcon('supplier')"></i>
                </th>
                <th (click)="sortData('sourcingType')">
                  Sourcing Type
                  <i [ngClass]="getSortIcon('sourcingType')"></i>
                </th>


                <th (click)="sortData('Isfinalized')">
                  Finalized
                  <i [ngClass]="getSortIcon('Isfinalized')"></i>
                </th>
                <th (click)="sortData('country')">
                  Country
                  <i [ngClass]="getSortIcon('country')"></i>
                </th>
                <th (click)="sortData('manufacturer')">
                  Make
                  <i [ngClass]="getSortIcon('manufacturer')"></i>
                </th>
                <th (click)="sortData('MPN')">
                  MPN
                  <i [ngClass]="getSortIcon('MPN')"></i>
                </th>
                <th (click)="sortData('Inventorylevel')">
                  Available Stock
                  <i [ngClass]="getSortIcon('Inventorylevel')"></i>
                </th>
                <th (click)="sortData('Price')">
                  Basic Price
                  <i [ngClass]="getSortIcon('Price')"></i>
                </th>

                <th (click)="sortData('Currency')">
                  Currency
                  <i [ngClass]="getSortIcon('Currency')"></i>
                </th>
                <th (click)="sortData('ConvertedPrice')">
                  Basic Price(INR)
                  <i [ngClass]="getSortIcon('ConvertedPrice')"></i>
                </th>
                <th (click)="sortData('MOQ')">
                  MOQ
                  <i [ngClass]="getSortIcon('MOQ')"></i>
                </th>
                <th (click)="sortData('Closest_Quantity')">
                  SPQ
                  <i [ngClass]="getSortIcon('Closest_Quantity')"></i>
                </th>
                <th (click)="sortData('estimatedFactoryLeadDays')">
                  Lead Time
                  <i [ngClass]="getSortIcon('estimatedFactoryLeadDays')"></i>
                </th>
                <th (click)="sortData('LandingCost')">
                  Est. Landing Cost
                  <i [ngClass]="getSortIcon('LandingCost')"></i>
                </th>
                <th (click)="sortData('Total_landing_cost')">
                  Total Landing Cost
                  <i [ngClass]="getSortIcon('Total_landing_cost')"></i>
                </th>

                <th (click)="sortData('Total_est_Cost')">
                  Total Est. Landing Cost(INR)
                  <i [ngClass]="getSortIcon('Total_est_Cost')"></i>
                </th>
                <th>
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of filteredSourceInfoData; let i = index">
                <td style="padding:0;">
                  <i class="fas fa-check-square check-icon"
                    [ngStyle]="{'color': data.isAuthorized ? 'blue' : 'lightgrey'}">
                  </i>
                </td>
                <td title="{{ data?.supplier }}">
                  <ng-container *ngIf="data?.clickUrl; else noLink">
                    <a [href]="data.clickUrl" target="_blank" rel="noopener noreferrer">
                      {{ data?.supplier }}
                    </a>
                  </ng-container>
                  <ng-template #noLink>
                    {{ data?.supplier }}
                  </ng-template>
                </td>


                <td (click)="openDatasheet(data)" [ngStyle]="{
      'color': data?.sourcingType === 'offline' ? 'orange' : (data?.sourcingType === 'vendor' ? 'rgb(0, 128, 0)' : (data?.sourcingType === 'nexar' ? '#0d6efd' : 'inherit')),
      'text-decoration': data?.DatasheetURL ? 'underline' : 'none',
      'cursor': data?.DatasheetURL ? 'pointer' : 'default'
    }" [ngClass]="{
      'fw-bold': data?.sourcingType === 'offline' || data?.sourcingType === 'nexar' || data?.sourcingType === 'vendor',
      'text-primary': data?.sourcingType === 'nexar'
    }" title="{{ data?.sourcingType }}">

                  {{
                  data?.sourcingType === 'offline' ? 'Offline' :
                  data?.sourcingType === 'nexar' ? 'Consolidator' :
                  data?.sourcingType === 'vendor' ? 'Direct' : data?.sourcingType
                  }}
                </td>


                <td title="{{data?.Isfinalized ? 'Yes' : 'No'}}">
                  <span [ngClass]="data?.Isfinalized ? 'text-success fw-bold' : 'text-muted fw-bold'">
                    {{ data?.Isfinalized ? 'Yes' : 'No' }}
                  </span>
                </td>
                <td title="{{data?.country}}">
                  {{ data?.country }}

                </td>
                <td class="position-relative" title="{{data?.manufacturer}}">{{
                  data?.manufacturer }}

                </td>
                <td title="{{data?.MPN}}">{{ data?.MPN }}</td>
                <td title="{{data?.Inventorylevel}}">{{ data?.Inventorylevel }}</td>
                <td title="{{data?.Price}}">
                  {{ data?.Price }}

                </td>
                <td title="{{data?.Currency}}">{{ data?.Currency }}</td>
                <td title="{{data?.ConvertedPrice}}">{{ data?.ConvertedPrice | number:'1.2-2' }}</td>
                <td title="{{data?.MOQ}}">{{ data?.MOQ }}</td>
                <td title="{{data?.Closest_Quantity}}">{{ data?.Closest_Quantity}}</td>
                <td title="{{data?.estimatedFactoryLeadDays}}">{{ data?.estimatedFactoryLeadDays | number:'1.2-2' }}
                </td>
                <td title="{{data?.LandingCost}}">{{ data?.LandingCost | number:'1.2-2' }}</td>
                <td title="{{data?.Total_landing_cost}}">{{ data?.Total_landing_cost | number:'1.2-2' }}</td>
                <td title="{{data?.Total_est_Cost}}">{{ data?.Total_est_Cost | number:'1.2-2' }}</td>

                <td class="action-td">
                  <div class="action-row">
                    <i class="fa-solid fa-circle-info action-circle info" title="Price Information"
                      (click)="onClickOfferPrice(offerPriceModal, data)"></i>

                    <i *ngIf="(data?.Specs && data.Specs.length) || hasTechSpecs(data)"
                      class="fa-solid fa-eye action-circle view" title="View Specifications"
                      (click)="specificationDetails(data)"></i>
                  </div>
                </td>

              </tr>
            </tbody>
          </table>

        </div>
      </div>
    </div>
  </div>
</div>

<div class="actions-section">

  <div class="action-cards-grid">
    <!-- Card for Procurement History -->
    <div class="action-card-wrapper" (click)="getProcurementHistory()">
      <div class="action-card card-action-blue">
        <div class="action-card-icon">
          <i class="fas fa-history"></i>
        </div>
        <div class="action-card-label">Procurement History</div>
      </div>
    </div>

    <!-- Card for Inventory History -->
    <div class="action-card-wrapper">
      <div class="action-card card-action-purple">
        <div class="action-card-icon">
          <i class="fas fa-warehouse"></i>
        </div>
        <div class="action-card-label">Inventory History</div>
      </div>
    </div>

    <!-- Card for Risk AI -->
    <div class="action-card-wrapper" (click)="onCardClick()">
      <div class="action-card card-action-gradient">
        <div class="action-card-icon">
          <i class="fas fa-brain"></i>
        </div>
        <div class="action-card-label">Risk AI</div>
      </div>
    </div>

    <!-- Card for Alternative -->
    <div class="action-card-wrapper" (click)="onAlternateClick()">
      <div class="action-card card-action-teal">
        <div class="action-card-icon">
          <i class="fas fa-sitemap"></i>
        </div>
        <div class="action-card-label">Alternative</div>
      </div>
    </div>

    <!-- Card for Part Alert -->
    <div class="action-card-wrapper" (click)="openAddPartModal()">
      <div class="action-card card-action-orange">
        <div class="action-card-icon">
          <i class="fas fa-bell"></i>
        </div>
        <div class="action-card-label">Part Alert</div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="showPopup" class="custom-name">
  <div class="popup-name">
    <div class="popup-headertop">
      <div type="button" class="close" (click)="closePopup()">&times;</div>
    </div>
    <div class="popup-body">
      <div *ngIf="!cleanedResHTML" class="loading">
        <div class="spinner"></div>
        <p style="color: green;">Fetching Risk AI</p>
      </div>
      <div id="risk-analysis-table" [innerHTML]="cleanedResHTML"></div>
    </div>
  </div>
</div>


<!-- Add Part Modal -->
<ng-template #addPartModal let-modal>
  <div class="add-part-modal">
    <!-- Header -->
    <div class="add-part-header">
      <div class="add-part-header-left">
        <div class="add-part-icon-wrap">
          <i class="fas fa-bell"></i>
        </div>
        <div>
          <div class="add-part-title">Part Alert</div>
          <div class="add-part-subtitle">Configure alert for part tracking</div>
        </div>
      </div>
      <button type="button" class="add-part-close" (click)="activeModal.close()">
        &times;
      </button>
    </div>

    <!-- Body -->
    <div class="add-part-body">
      <form [formGroup]="partForm">

        <!-- Part Details Section -->
        <div class="add-part-section">
          <div class="add-part-section-title">
            <i class="fas fa-microchip"></i> Part Details
          </div>
          <div class="add-part-fields-grid">

            <div class="add-part-field">
              <label for="projectName">Project Name</label>
              <input type="text" id="projectName" formControlName="projectName" />
            </div>

            <div class="add-part-field">
              <label for="internalPartNo">Internal Part No.</label>
              <input type="text" id="internalPartNo" formControlName="internalPartNo" />
            </div>

            <div class="add-part-field">
              <label for="MPN">MPN</label>
              <input type="text" id="MPN" formControlName="MPN" />
            </div>

            <div class="add-part-field">
              <label for="uom">UOM</label>
              <input type="text" id="uom" formControlName="uom" />
            </div>

            <div class="add-part-field">
              <label for="requiredQuantity">Required Quantity</label>
              <input type="number" id="requiredQuantity" formControlName="requiredQuantity" />
            </div>

            <div class="add-part-field">
              <label for="frequency">Frequency</label>
              <select id="frequency" formControlName="frequency">
                <option [ngValue]="null" disabled>Select frequency</option>
                <option *ngFor="let option of frequencyOptions" [ngValue]="option">
                  {{ option.scheduleType }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="add-part-footer">
          <button type="button" class="add-part-btn-cancel" (click)="activeModal.close()">
            <i class="fas fa-times"></i> Cancel
          </button>
          <button type="button" class="add-part-btn-submit" (click)="submitAddPart()" [disabled]="partForm.invalid">
            <i class="fas fa-plus"></i> Add Part
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #offerPriceModal let-modal>
  <div class="op-modal-wrapper">

    <!-- ── Header ── -->
    <div class="op-header">
      <div class="op-header-left">
        <div class="op-header-badge">
          <i class="fas fa-tag"></i>
        </div>
        <div class="op-header-info">
          <h5 class="op-header-title">Price Information</h5>
          <span class="op-header-subtitle">
            <ng-container *ngIf="selectedSupplierData?.companyName; else noCompany">
              <i class="fas fa-store"></i>&nbsp;{{ selectedSupplierData?.companyName }}
            </ng-container>
            <ng-template #noCompany>Supplier price tiers &amp; offer details</ng-template>
          </span>
        </div>
      </div>
      <button type="button" class="op-close-btn" (click)="closeModal()" title="Close">&times;</button>
    </div>

    <!-- ── Key Info Cards + Descriptions ── -->
    <div class="op-split-cards-container"
      [class.op-split-cards-container--single]="!hasDescriptionDetails(selectedSupplierData)">

      <!-- Left: Info Cards -->
      <div class="op-cards-main-col">
        <div class="op-section-label">
          <i class="fas fa-info-circle"></i> Part &amp; Supplier Details
        </div>
        <div class="op-cards-grid">

          <div class="op-card" *ngIf="hasValue(selectedSupplierData?.MPN)" title="{{ selectedSupplierData?.MPN }}">
            <div class="op-card-icon op-card-icon--blue">
              <i class="fas fa-microchip"></i>
            </div>
            <div class="op-card-body">
              <span class="op-card-label">MPN</span>
              <span class="op-card-value">{{ selectedSupplierData?.MPN }}</span>
            </div>
          </div>

          <div class="op-card" *ngIf="hasValue(selectedSupplierData?.manufacturer)"
            title="{{ selectedSupplierData?.manufacturer }}">
            <div class="op-card-icon op-card-icon--indigo">
              <i class="fas fa-industry"></i>
            </div>
            <div class="op-card-body">
              <span class="op-card-label">Manufacturer</span>
              <span class="op-card-value">{{ selectedSupplierData?.manufacturer }}</span>
            </div>
          </div>

          <div class="op-card" *ngIf="hasValue(selectedSupplierData?.currency)">
            <div class="op-card-icon op-card-icon--amber">
              <i class="fas fa-coins"></i>
            </div>
            <div class="op-card-body">
              <span class="op-card-label">Currency</span>
              <span class="op-card-value">{{ selectedSupplierData?.currency }}</span>
            </div>
          </div>

          <div class="op-card" *ngIf="hasValue(selectedSupplierData?.stored_at)">
            <div class="op-card-icon op-card-icon--teal">
              <i class="fas fa-calendar-alt"></i>
            </div>
            <div class="op-card-body">
              <span class="op-card-label">Fetched Date</span>
              <span class="op-card-value">{{ selectedSupplierData?.stored_at | date: 'dd/MM/yyyy' }}</span>
            </div>
          </div>

          <ng-container *ngFor="let item of getStandardPricingDetails(selectedSupplierData)">
            <div class="op-card" title="{{ item.value }}">
              <div class="op-card-icon op-card-icon--slate">
                <i [class]="item.icon || 'fas fa-info-circle'"></i>
              </div>
              <div class="op-card-body">
                <span class="op-card-label">{{ item.label }}</span>
                <span class="op-card-value">{{ item.value }}</span>
              </div>
            </div>
          </ng-container>

        </div>
      </div>

      <!-- Right: Description Panel -->
      <div class="op-cards-desc-col" *ngIf="hasDescriptionDetails(selectedSupplierData)">
        <div class="op-section-label">
          <i class="fas fa-align-left"></i> Key Descriptions
        </div>
        <div class="op-desc-panel">
          <div *ngFor="let desc of getDescriptionPricingDetails(selectedSupplierData)" class="op-desc-card"
            [ngClass]="'op-desc-card--' + desc.type">
            <div class="op-desc-card-top">
              <span class="op-desc-chip" [ngClass]="'op-desc-chip--' + desc.type">
                <i [class]="desc.icon"></i>{{ desc.label }}
              </span>
            </div>
            <div class="op-desc-text-box">
              <span class="op-desc-text">{{ desc.value }}</span>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- ── Price Tiers Table ── -->
    <div class="op-table-wrap">
      <div class="op-section-label op-section-label--table">
        <i class="fas fa-layer-group"></i> Price Tiers
        <span class="op-tier-count" *ngIf="offerPriceListDetails?.length > 0">
          {{ offerPriceListDetails?.length }} tier(s)
        </span>
      </div>

      <div class="op-table-container custom-modal-scrollbar">
        <!-- Empty State -->
        <div *ngIf="offerPriceListDetails?.length === 0" class="op-empty-state">
          <div class="op-empty-icon-wrap">
            <i class="fas fa-inbox"></i>
          </div>
          <p class="op-empty-title">No price offers available</p>
          <p class="op-empty-sub">No offer tiers found for this part</p>
        </div>

        <!-- Price Tiers Table -->
        <table *ngIf="offerPriceListDetails?.length > 0" class="op-table">
          <thead>
            <tr>
              <th class="op-th op-th--center" style="width: 64px;">Select</th>
              <th class="op-th">
                <i class="fas fa-cubes"></i>Quantity
              </th>
              <th class="op-th">
                <i class="fas fa-tag"></i>Unit Price
              </th>
              <th class="op-th">
                <i class="fas fa-rupee-sign"></i>Unit Price (INR)
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of offerPriceListDetails; let i = index"
              [class.op-tr-selected]="selectedPriceRowIndex === i" (click)="selectPriceRow(i)">
              <td class="op-td op-td--center" (click)="$event.stopPropagation()">
                <input type="checkbox" [checked]="selectedPriceRowIndex === i" (change)="selectPriceRow(i)"
                  class="op-checkbox" />
              </td>
              <td class="op-td">
                <span class="op-qty-badge">
                  <i class="fas fa-box"></i>{{ data?.quantity | number }}
                </span>
              </td>
              <td class="op-td">
                <span class="op-unit-price">
                  <span class="currency-tag" *ngIf="selectedSupplierData?.currency">{{ selectedSupplierData?.currency
                    }}</span>
                  {{ data?.price | number:'1.2-4' }}
                </span>
              </td>
              <td class="op-td">
                <span class="op-price-badge">
                  <i class="fas fa-rupee-sign"></i>{{ data?.convertedPrice | number:'1.2-2' }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- ── Footer ── -->
    <div class="op-footer">
      <span class="op-footer-count">
        <i class="fas fa-layer-group"></i>
        <span>Total: <strong>{{ offerPriceListDetails?.length || 0 }}</strong> offer tier(s)</span>
      </span>
      <div class="op-footer-actions">
        <button type="button" class="op-btn-close" (click)="closeModal()">
          <i class="fas fa-times"></i> Cancel
        </button>
        <button
          *ngIf="selectedPriceRowIndex !== null && !(role === 'Engineer' && projectStatus === 'Closed') && !isReviewStage"
          type="button" class="op-btn-save" (click)="savePriceData()">
          <i class="fas fa-check-circle"></i> Update Price
        </button>
      </div>
    </div>

  </div>
</ng-template><!-- Offline Confirmation Modal -->
<ng-template #offlineConfirmModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Confirm Update</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body text-center">
    <p class="mb-4">Do you really want to finalize this supplier?</p>
  </div>
  <div class="modal-footer justify-content-center">
    <button *ngIf="!isReviewStage" type="button" class="btn btn-outline-primary btn-sm"
      (click)="confirmOfflineUpdate()">Yes</button>
    <button type="button" class="btn btn-outline-primary btn-sm" (click)="modal.dismiss()">No</button>

  </div>
</ng-template>
<div *ngIf="showPopup1">
  <div class="modal-backdrop fade show"></div>
  <div class="modal d-block" tabindex="-1">
    <div class="modal-dialog modal-xl custom-modal-scrollbar" style="max-width:92vw; max-height:92vh;">
      <div class="ph-modal-content">

        <!-- ── Header ── -->
        <div class="ph-header">
          <div class="ph-header-left">
            <div class="ph-header-icon">
              <i class="fas fa-clock-rotate-left"></i>
            </div>
            <div>
              <h5 class="ph-title">Procurement History</h5>
              <p class="ph-subtitle">PO &amp; price records for this part</p>
            </div>
          </div>
          <button type="button" class="ph-close-btn" (click)="closePriceHistory()">&times;</button>
        </div>

        <!-- ── Summary Cards ── -->
        <div class="ph-cards-section">
          <div class="ph-cards-grid">

            <div class="ph-card">
              <div class="ph-card-icon" style="background: linear-gradient(135deg,#667eea,#764ba2);">
                <i class="fas fa-microchip"></i>
              </div>
              <div class="ph-card-body">
                <span class="ph-card-label">Internal Part No</span>
                <span class="ph-card-value" title="{{ priceSummary?.internalPartNumber }}">{{
                  priceSummary?.internalPartNumber }}</span>
              </div>
            </div>

            <div class="ph-card">
              <div class="ph-card-icon" style="background: linear-gradient(135deg,#43e97b,#38f9d7);">
                <i class="fas fa-arrow-down"></i>
              </div>
              <div class="ph-card-body">
                <span class="ph-card-label">Min Price (₹)</span>
                <span class="ph-card-value">{{ priceSummary?.minPriceINR | number:'1.2-2' }}</span>
              </div>
            </div>

            <div class="ph-card">
              <div class="ph-card-icon" style="background: linear-gradient(135deg,#f5576c,#f093fb);">
                <i class="fas fa-arrow-up"></i>
              </div>
              <div class="ph-card-body">
                <span class="ph-card-label">Max Price (₹)</span>
                <span class="ph-card-value">{{ priceSummary?.maxPriceINR | number:'1.2-2' }}</span>
              </div>
            </div>

            <div class="ph-card">
              <div class="ph-card-icon" style="background: linear-gradient(135deg,#4facfe,#00f2fe);">
                <i class="fas fa-calculator"></i>
              </div>
              <div class="ph-card-body">
                <span class="ph-card-label">Avg Price (₹)</span>
                <span class="ph-card-value">{{ priceSummary?.weightedAveragePriceINR | number:'1.2-2' }}</span>
              </div>
            </div>

            <div class="ph-card">
              <div class="ph-card-icon" style="background: linear-gradient(135deg,#ffa751,#ffe259);">
                <i class="fas fa-file-invoice"></i>
              </div>
              <div class="ph-card-body">
                <span class="ph-card-label">Purchase Count</span>
                <span class="ph-card-value">{{ priceSummary?.purchaseCount }}</span>
              </div>
            </div>

            <div class="ph-card">
              <div class="ph-card-icon" style="background: linear-gradient(135deg,#fa709a,#fee140);">
                <i class="fas fa-boxes-stacked"></i>
              </div>
              <div class="ph-card-body">
                <span class="ph-card-label">Required Qty</span>
                <span class="ph-card-value">{{ priceSummary?.projectQty | number:'1.2-2' }}</span>
              </div>
            </div>

          </div>
        </div>

        <!-- ── PO History Table ── -->
        <div class="ph-table-section table-scroll-area">
          <table class="table table-bordered table-sm custom-hover shadow-sm bg-white"
            style="font-size: 13px; margin-bottom: 0;">
            <thead class="table-secondary sticky-top sticky-header">
              <tr>
                <th (click)="onSort('poNumber')" class="ph-th">
                  PO Number <span *ngIf="sortColumn === 'poNumber'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
                </th>
                <th (click)="onSort('poDate')" class="ph-th">
                  PO Date <span *ngIf="sortColumn === 'poDate'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
                </th>
                <th (click)="onSort('projectNumber')" class="ph-th">
                  Project Name <span *ngIf="sortColumn === 'projectNumber'">{{ sortDirection === 'asc' ? '▲' : '▼'
                    }}</span>
                </th>
                <th (click)="onSort('supplierName')" class="ph-th">
                  Supplier Name <span *ngIf="sortColumn === 'supplierName'">{{ sortDirection === 'asc' ? '▲' : '▼'
                    }}</span>
                </th>
                <th (click)="onSort('internalPartNumber')" class="ph-th">
                  Internal Part No <span *ngIf="sortColumn === 'internalPartNumber'">{{ sortDirection === 'asc' ? '▲' :
                    '▼' }}</span>
                </th>
                <th (click)="onSort('mpn')" class="ph-th">
                  MPN <span *ngIf="sortColumn === 'mpn'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
                </th>
                <th (click)="onSort('uom')" class="ph-th">
                  UOM <span *ngIf="sortColumn === 'uom'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
                </th>
                <th (click)="onSort('qty')" class="ph-th">
                  Quantity <span *ngIf="sortColumn === 'qty'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
                </th>
                <th (click)="onSort('unitPrice')" class="ph-th">
                  Unit Price <span *ngIf="sortColumn === 'unitPrice'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
                </th>
                <th (click)="onSort('currency')" class="ph-th">
                  Currency <span *ngIf="sortColumn === 'currency'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
                </th>
                <th (click)="onSort('unitPriceINR')" class="ph-th">
                  Unit Price (INR) <span *ngIf="sortColumn === 'unitPriceINR'">{{ sortDirection === 'asc' ? '▲' : '▼'
                    }}</span>
                </th>
                <th (click)="onSort('landing_INR_cost')" class="ph-th">
                  Landing Cost <span *ngIf="sortColumn === 'landing_INR_cost'">{{ sortDirection === 'asc' ? '▲' : '▼'
                    }}</span>
                </th>
                <th (click)="onSort('stockAvailability')" class="ph-th">
                  Stock Availability <span *ngIf="sortColumn === 'stockAvailability'">{{ sortDirection === 'asc' ? '▲' :
                    '▼' }}</span>
                </th>
                <th class="ph-th">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of selectedPriceHistory">
                <td>{{ row.poNumber }}</td>
                <td>{{ row.poDate | date: 'dd-MMM-yyyy' }}</td>
                <td>{{ row.projectNumber }}</td>
                <td>{{ row.supplierName }}</td>
                <td>{{ row.internalPartNumber }}</td>
                <td>{{ row.mpn }}</td>
                <td>{{ row.uom }}</td>
                <td>{{ row.qty }}</td>
                <td>{{ row.unitPrice | number:'1.2-2' }}</td>
                <td>{{ row.currency }}</td>
                <td>{{ row.unitPriceINR | number:'1.2-2' }}</td>
                <td>{{ row.landing_INR_cost | number:'1.2-2' }}</td>
                <td>{{ row.stockAvailability }}</td>
                <td class="text-center">
                  <input type="checkbox" [(ngModel)]="row.isSelected" (change)="onSelectHistory(row)">
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- ── Footer ── -->
        <div class="ph-footer">
          <span class="ph-footer-info">
            <i class="fas fa-info-circle"></i>
            Total: <strong>{{ selectedPriceHistory?.length || 0 }}</strong> record(s)
          </span>
          <div class="ph-footer-actions">
            <button *ngIf="showSendButton && !isReviewStage" class="ph-btn-update" (click)="sendSelectedHistory()">
              <i class="fas fa-save"></i> Update
            </button>
            <button class="ph-btn-close" (click)="closePriceHistory()">
              <i class="fas fa-times"></i> Close
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<!-- Ambient Top Shimmer Bar -->
<div *ngIf="isLoading" class="loading-bar"></div>

<!-- Super Modern Loading Overlay -->
<div *ngIf="isLoading" class="sb-loading-overlay">
  <div class="sb-loading-card">
    <div class="sb-spinner-container">
      <div class="sb-spinner-ring"></div>
      <div class="sb-spinner-ring-inner"></div>
      <div class="sb-spinner-core">
        <i class="fa fa-microchip sb-spinner-icon"></i>
      </div>
    </div>
    <div class="sb-loading-content">
      <h4 class="sb-loading-title">{{ loadingTitle }}</h4>
      <p class="sb-loading-subtitle">{{ loadingSubtitle }}</p>
    </div>
    <div class="sb-loading-progress-bar">
      <div class="sb-loading-progress-indeterminate"></div>
    </div>
  </div>
</div>
